/* WFG Product Page — Dynamic gallery/info split + badge placement */
(function () {
  function setGalleryWidth() {
    var gallery = document.querySelector('.shopify-section--main-product product-gallery');
    var product = document.querySelector('.shopify-section--main-product .product');
    if (!gallery || !product) return;
    var w = gallery.getBoundingClientRect().width;
    if (w > 0) {
      product.style.setProperty('--wfg-gallery-w', Math.round(w) + 'px');
    }
  }

  /* Move the badge next to Build Time, at the top of the column (10/4/26,
     revised twice same day after Clint saw each pass).
     Clint: "lead times need to be one of the first things people see
     rather than the last before they add to cart... move lead times up
     above the product title. And if there's a badge, like a custom badge,
     then it sits to the right of it." Then, after seeing it on the right:
     "i meant move it to the left side."

     text_wynk99 (the Build Time block - either a plain "Build Time: X" line,
     or the full wfg-christmas-badge plaque when a product has a Christmas
     cutoff date, see the "Christmas order-cutoff badge" rule in
     wfg-product.css) was moved to the very front of block_order in
     templates/product.custom-fenoglio-boots.json (and, 10/4/26, the three
     other product templates that carry this same block: the default
     templates/product.json, product.corporate-coasters.json, and
     product.hermann-oak.json), ahead of the title.

     FIRST PASS (replaced): badge-list appended as a sibling AFTER whatever
     Build Time rendered. Fine for the plain-text case, but the plaque is its
     own width:100% flex row with no spare room beside it, so the badge
     wrapped below instead of sitting next to it.

     SECOND PASS (replaced): badge moved INSIDE the plaque, appended AFTER
     a wrapper around the plaque's existing text content, docked to the
     right via margin-left:auto. Fixed the Christmas case, but put the
     badge on the wrong side per Clint's follow-up.

     THIRD PASS (current): badge-list is now inserted BEFORE the text
     wrapper in both cases - plaque and plain-text - so it reads
     [badge][text] left to right. No margin-left:auto needed any more: with
     the badge first and the text wrapper taking the remaining flexible
     width, natural flex order already puts the badge flush left and the
     text filling the rest of the row, using the row's own `gap` (already
     set on .wfg-christmas-badge / .wfg-leadtime-row) for the space between
     them instead of an auto margin.

     LABEL SHORTENING REMOVED (10/4/26): a badge chip sharing the row with
     the plaque used to shorten the plaque's "Lead Time: X" text down to
     "Lead X" so the row wouldn't wrap. Clint: "I don't care about the line
     break. Add lead time" - the full "Lead Time: " label is now always left
     intact, badge or no badge; the plaque is allowed to wrap to two lines
     when a wide badge chip is present.
     LABEL RENAMED 10/4/26: "Lead Time" -> "Build Time" sitewide (Clint's call).

     Two CSS-only routes were tried and rejected (same reasoning all three
     passes): `order` does nothing on the display:block block-list without
     switching the WHOLE list to flex (which breaks the tuned margin-
     collapse spacing rhythm elsewhere in this file), and CSS alone cannot
     merge several existing sibling text/link nodes into one flex item - a
     real wrapper element is required, hence the DOM work here.

     The script is loaded with `defer`, so the document is fully parsed
     when this runs and the move happens before first paint. */
  function moveBadgeNextToLeadTime() {
    var list = document.querySelector('.shopify-section--main-product .product-info__block-list');
    if (!list) return;
    var badges = list.querySelector('badge-list');
    if (!badges || badges.getAttribute('data-wfg-moved') === '1') return;
    var leadTime = list.querySelector('[data-block-id="text_wynk99"]');
    if (!leadTime) return;

    var plaque = leadTime.querySelector('.wfg-christmas-badge');
    if (plaque) {
      var contentWrap = document.createElement('span');
      contentWrap.className = 'wfg-christmas-badge__content';
      while (plaque.firstChild) {
        contentWrap.appendChild(plaque.firstChild);
      }
      plaque.insertBefore(contentWrap, null);
      plaque.insertBefore(badges, contentWrap);
      plaque.classList.add('wfg-leadtime-badge-inline');
    } else {
      leadTime.classList.add('wfg-leadtime-row');
      leadTime.insertBefore(badges, leadTime.firstChild);
    }
    badges.setAttribute('data-wfg-moved', '1');
  }

  /* Complimentary postcard opt-in: moved below Add to Cart (10/4/26).
     Clint: "it doesn't need to sit up top. it actually needs to sit down...
     either above add to cart or below add to cart, probably below add to
     cart." The checkbox markup (snippets/wfg-christmas-cutoff.liquid,
     --after state only) renders INSIDE the Build Time block-item, right
     after the plaque - that's fixed by Liquid, not something block_order
     can move on its own (same limitation as the badge above: it isn't a
     separate block). Relocated here in JS instead: wrapped in its own
     block-item and inserted immediately after the buy-buttons block-item
     (the one containing the Add to Cart form), so it now sits directly
     below Add to Cart regardless of where Build Time sits in the column. */
  function movePostcardBelowAddToCart() {
    var optin = document.querySelector('.wfg-postcard-optin');
    if (!optin || optin.getAttribute('data-wfg-moved') === '1') return;
    var buyButtonsItem = document.querySelector(
      '.shopify-section--main-product .product-info__block-item:has(.shopify-product-form), ' +
      '.shopify-section--main-product .product-info__block-item:has(.product-form)'
    );
    if (!buyButtonsItem || !buyButtonsItem.parentNode) return;
    var holder = document.createElement('div');
    holder.className = 'product-info__block-item wfg-postcard-row';
    holder.appendChild(optin);
    buyButtonsItem.parentNode.insertBefore(holder, buyButtonsItem.nextSibling);
    optin.setAttribute('data-wfg-moved', '1');
  }

  /* Complimentary postcard opt-in - cart wiring (added 9/30/26).
     The checkbox has no native <form> of its own, wherever it currently sits
     in the DOM (see movePostcardBelowAddToCart above), so checking it can't
     submit as a cart line item property on its own.
     Fix: on change, find the page's actual add-to-cart form (same selector
     buy-buttons.liquid's own inline script already uses: form[action*="/cart/add"]),
     and inject/remove a hidden properties[Complimentary Postcard] input directly
     into it. That hidden input rides along with the native form submit (or the
     theme's Ajax add-to-cart fetch, which also reads from the same <form> via
     FormData) with no app and no edit to buy-buttons.liquid itself.
     Delegated on document so it keeps working no matter where the badge/postcard
     blocks get moved around the DOM. */
  function wirePostcardOptIn() {
    document.addEventListener('change', function (e) {
      var cb = e.target;
      if (!cb || !cb.matches || !cb.matches('[data-wfg-postcard-optin]')) return;

      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      var existing = form.querySelector('[data-wfg-postcard-optin-input]');

      if (cb.checked) {
        if (!existing) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[Complimentary Postcard]';
          input.value = 'Yes, send with order';
          input.setAttribute('data-wfg-postcard-optin-input', '1');
          form.appendChild(input);
        }
      } else if (existing) {
        existing.remove();
      }
    });
  }

  function init() {
    moveBadgeNextToLeadTime();
    movePostcardBelowAddToCart();
    setGalleryWidth();
    wirePostcardOptIn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', setGalleryWidth, { passive: true });
})();